/**
 * 首页静态数据
 */

// 首页轮播图数据
export const homeCarouselData = [
  {
    id: '1',
    img: '/img/home/carousel/carousel_1.jpg',
    title: '瑞谦智能，让生活进化',
    text: '瑞谦智能深耕以大数据、人工智能、云计算为新一代信息手段的智慧城市、智慧园区、智慧政务、智慧交通等领域，推动管理手段、管理模式、管理理念，从数字化到智能化再到智慧化发展'
  },
  {
    id: '2',
    img: '/img/home/carousel/carousel_2.jpg',
    title: '瑞谦智能，让生活进化',
    text: '瑞谦智能深耕以大数据、人工智能、云计算为新一代信息手段的智慧城市、智慧园区、智慧政务、智慧交通等领域，推动管理手段、管理模式、管理理念，从数字化到智能化再到智慧化发展'
  },
  {
    id: '3',
    img: '/img/home/carousel/carousel_3.jpg',
    title: '瑞谦智能，让生活进化',
    text: '瑞谦智能深耕以大数据、人工智能、云计算为新一代信息手段的智慧城市、智慧园区、智慧政务、智慧交通等领域，推动管理手段、管理模式、管理理念，从数字化到智能化再到智慧化发展'
  }
]

// 首页核心技术数据
export const homeCoreTechData = [
  {
    id: '1',
    img: '/img/home/slideCard/slide_1.jpg',
    title: '视线跟踪技术（疲劳状态检测）',
    overview: '视线跟踪技术有助于确定人在数字屏幕上的注视位置，反馈眨眼频率以及瞳孔对不同刺激的反应。因此，它有助于确定一个人的视线方向，是否困倦，判断他的焦点等。该技术在智能手机、AR/VR游戏、智能汽车等领域的人机交互有着广泛的应用前景。',
    url: ''
  },
  {
    id: '2',
    img: '/img/home/slideCard/slide_2.jpg',
    title: 'NB-IOT 物联通讯技术',
    overview: 'NB-IOT是窄带物联网的关键技术，显著特征如下：强链接：同一基站，NB-IoT比现有无线技术提供50-100倍的接入数。一个扇区能够支持10万个连接；',
    url: ''
  },
  {
    id: '3',
    img: '/img/home/slideCard/slide_3.jpg',
    title: ' NNIE卷积神经网络引擎加速',
    overview: '某品牌中专门针对神经网络特别是深度学习卷积神经网络进行加速处理的硬件单元，人脸识别算法的处理速度在设备层面达到毫秒级运算。带有NNIE加速引擎NPU单元的SoC芯片让人工智能算法的运算速度成倍地增加，设备功耗成倍地降低，真正的智能终端产品成为现实。',
    url: ''
  },
  {
    id: '4',
    img: '/img/home/slideCard/slide_4.jpg',
    title: '机器视觉',
    overview: '以AI+3D为核心，搭建新一代机器视觉智能编程环境，可视化、无代码的编程界面，一键仿真，实现产品标准化、全场景应用。视觉算法具有精度高、视野大，优异的抗环境光性能。',
    url: ''
  },
  {
    id: '5',
    img: '/img/home/slideCard/slide_5.jpg',
    title: '基于人脸识别的轨迹检测跟踪技术',
    overview: '基于人脸识别的轨迹检测跟踪技术采用区域特征分析算法，融合了计算机图像处理技术与生物统计学原理于一体，利用计算机图像处理技术从视频中提取人像特征点，利用生物统计学的原理进行分析建立数学模型，具有广阔的发展前景。基于人脸识别的轨迹检测跟踪系统通过各人脸识别摄像机与服务器协同合作进行人员的实时跟踪，为管理人员提供了人员的实时位置信息，同时为查阅人员行走轨迹和视频提供了支持，便于管理人员管理监管区域。',
    url: ''
  },
  {
    id: '6',
    img: '/img/home/slideCard/slide_6.jpg',
    title: '人脸搜索',
    overview: '给定一张照片，对比人脸库中N张人脸，进行1：N、M：N检索，找出最相似的一张或多张人脸，并返回相似度分数。支持百万级人脸库管理。',
    url: ''
  }
]

// 首页解决方案数据
export const homeSchemeData = [
  {
    id: '1',
    iconImg: '/img/home/scheme/zhihuiyuanqu.png',
    title: '智慧园区',
    content: '瑞谦智慧园区解决方案以"以人为本，绿色高效，业务增值"的目标，利用物联网、大数据、人工智能等技术，搭建一体可视化综合管理平台...'
  },
  {
    id: '2',
    iconImg: '/img/home/scheme/zhihuishequ.png',
    title: '智慧社区',
    content: '瑞谦智慧社区解决方案以"互联网+"为基础，社区服务、智能家居为核心，围绕社区安全、生活娱乐、物业管理、医疗教育等需求，借助物联网、人工智能、大数据等新技术，把物业服务、安防管理、社区民生服务等集成在一个社区运营平台。'
  },
  {
    id: '3',
    iconImg: '/img/home/scheme/zhihuixuexiao.png',
    title: '智慧学校',
    content: '瑞谦智慧学校解决方案以"互联网+"为基础，以智慧学校为业务主体，围绕学校教务、学生管理、学校生活、学校运营、学校管理、学校教务等需求，借助物联网、人工智能、大数据等新技术，把教务、学生管理、学校生活、学校运营、学校管理、学校教务等集成。'
  },
  {
    id: '4',
    iconImg: '/img/home/scheme/renzhizhineng.png',
    title: '认知智能',
    content: '理解：语言、图像、视频、理解<br>知识：知识表示与逻辑推理<br> 交互：问答、对话、聊天等<br>决策：效用函数，贝叶斯决策理论等。'
  },
  {
    id: '5',
    iconImg: '/img/home/scheme/ganzhizhineng.png',
    title: '感知智能',
    content: '瑞谦智慧社区解决方案以"互联网+"为基础，社区服务、智能家居为核心，围绕社区安全、生活娱乐、物业管理、医疗教育等需求，借助物联网、人工智能、大数据等新技术，把物业服务、安防管理、社区民生服务等集成在一个社区运营平台。'
  },
  {
    id: '6',
    iconImg: '/img/home/scheme/jiqixuexi.png',
    title: '机器学习',
    content: '专门研究计算机怎样模拟或实现人类的学习行为，以获取新的知识或技能，重新组织已有的知识结构使之不断改善自身的性能。'
  },
  {
    id: '7',
    iconImg: '/img/home/scheme/yunjisuan.png',
    title: '云计算',
    content: '是指通常使用很多处理器或者某一集群中组织的几台计算机的计算系统和环境。'
  },
  {
    id: '8',
    iconImg: '/img/home/scheme/dashuju.png',
    title: '大数据',
    content: '瑞谦智慧社区解决方案以"互联网+"为基础，社区服务、智能家居为核心，围绕社区安全、生活娱乐、物业管理、医疗教育等需求，借助物联网、人工智能、大数据等新技术，把物业服务、安防管理、社区民生服务等集成在一个社区运营平台。'
  }
]

// 首页新闻数据
export const homeNewsData = [
  {
    id: '1',
    img: '/img/home/news/news_1.jpg',
    title: '聚焦 | 省委书记尹力莅临瑞谦智能调研考察',
    overview: '12月25日下午，省委书记尹力一行莅临瑞谦智能调研考察。',
    url: ''
  },
  {
    id: '2',
    img: '/img/home/news/news_2.png',
    title: '聚焦 | 全国政协副主席、全国工商联主席高云龙一行莅临瑞谦公司视察指导',
    overview: '9月26日上午，全国政协副主席、中华全国工商业联合会主席、中国民间商会会长高云龙一行莅临瑞谦智能视察指导工作，实验区管委会主任林文耀带领相关部门陪同视察。',
    url: ''
  },
  {
    id: '3',
    img: '/img/home/news/news_3.jpg',
    title: '为梦想 不止步 | 瑞谦2025年会暨表彰大会圆满举行',
    overview: '',
    url: ''
  }
]

// 首页公司介绍数据
export const homeIntroData = [
  {
    id: '1',
    img: '/img/home/introduce/bg.jpg',
    title: '公司简介',
    overview: '福建平潭瑞谦智能科技有限公司是一家专业从事人工智能软件开发的高新技术企业，致力于为学校、企业、政务客户提供集软件开发、系统集成、IT运维等一体的信息化综合解决方案。公司拥有自主知识产权的深度学习核心算法技术、神经网络计算引擎技术，为客户提供国内外领先的人工智能物联网智慧终端和数据平台。',
    url: ''
  }
]

